import {
  REPORTS_REQUEST,
  CF_REPORTS_SUCCESS,
  FAILURE,
  SLICES_REQUEST,
  SLICES_SUCCESS,
  MTM_REPORTS_SUCCESS,
  VAR_REPORTS_SUCCESS,
  PROJECTED_VAR_REPORTS_SUCCESS,
  ALERTS_REQUEST,
  ALERTS_SUCCESS,
  SUMMARY_REQUEST,
  SUMMARY_SUCCESS,
  INSTRUMENT_SUCCESS,
  INSTRUMENT_REQUEST,
  SET_SLICE,
  INSTRUMENT_SUMMARY_SUCCESS,
  SET_TKR_CUSIP,
  SET_SUMMARY_DATE,
  PROJECTED_VAR_REPORTS_FAILURE,
  CORRESPONDENT_SUCCESS,
  CF_REPORTS_FAILURE,
  MTM_REPORTS_FAILURE,
  VAR_REPORTS_FAILURE,
  ALERTS_FAILURE,
  SUMMARY_FAILURE,
  SLICES_FAILURE,
  INSTRUMENT_FAILURE,
  INSTRUMENT_SUMMARY_FAILURE,
  CORRESPONDENT_FAILURE,
} from "./constants";
import { action } from "typesafe-actions";
import { TkrCusip, InstrumentParams, Slice } from "../../types";

export function reportsRequest(params: Slice, token: string) {
  return {
    type: REPORTS_REQUEST,
    params: {
      date: params.date,
      id: params.id,
    },
    token: token,
  };
}

export function slicesRequest(date: string, token: string) {
  return {
    type: SLICES_REQUEST,
    params: date,
    token: token,
  };
}

export function summaryRequest(date: string, token: string) {
  return {
    type: SUMMARY_REQUEST,
    date: date,
    token: token,
  };
}

export function alertsRequest(token: string) {
  return {
    type: ALERTS_REQUEST,
    token: token,
  };
}

export function instrumentRequest(params: InstrumentParams, token: string) {
  return {
    type: INSTRUMENT_REQUEST,
    params: params,
    token: token,
  };
}

export const cfReportSuccess = (res: any) => action(CF_REPORTS_SUCCESS, res);
export const mtmReportSuccess = (res: any) => action(MTM_REPORTS_SUCCESS, res);
export const varReportSuccess = (res: any) => action(VAR_REPORTS_SUCCESS, res);
export const projectedVarReportSuccess = (res: any) =>
  action(PROJECTED_VAR_REPORTS_SUCCESS, res);
export const projectedVarReportError = (err: any) =>
  action(PROJECTED_VAR_REPORTS_FAILURE, err);

export const alertsSuccess = (res: any) => action(ALERTS_SUCCESS, res);
export const summarySuccess = (res: any) => action(SUMMARY_SUCCESS, res);
export const slicesSuccess = (res: string[]) => action(SLICES_SUCCESS, res);
export const instrumentSuccess = (res: string[]) =>
  action(INSTRUMENT_SUCCESS, res);
export const instrumentSummarySuccess = (res: string[]) =>
  action(INSTRUMENT_SUMMARY_SUCCESS, res);
export const correspondentSuccess = (res: any) =>
  action(CORRESPONDENT_SUCCESS, res);

export const cfReportError = (err: any) => action(CF_REPORTS_FAILURE, err);
export const mtmReportError = (err: any) => action(MTM_REPORTS_FAILURE, err);
export const varReportError = (err: any) => action(VAR_REPORTS_FAILURE, err);
export const alertsError = (err: any) => action(ALERTS_FAILURE, err);
export const summaryError = (err: any) => action(SUMMARY_FAILURE, err);
export const slicesError = (err: any) => action(SLICES_FAILURE, err);
export const instrumentError = (err: any) => action(INSTRUMENT_FAILURE, err);
export const instrumentSummaryError = (err: any) =>
  action(INSTRUMENT_SUMMARY_FAILURE, err);
export const correspondentError = (err: any) =>
  action(CORRESPONDENT_FAILURE, err);

export const setSliceDate = (res: Slice) => action(SET_SLICE, res);
export const setSummaryDate = (res: string) => action(SET_SUMMARY_DATE, res);
export const setTkrCusip = (res: TkrCusip) => action(SET_TKR_CUSIP, res);
export const error = (err: any) => action(FAILURE, err);
